import { render, staticRenderFns } from "./tableRegisterReport.vue?vue&type=template&id=1807e7ce&scoped=true&"
import script from "./tableRegisterReport.vue?vue&type=script&lang=js&"
export * from "./tableRegisterReport.vue?vue&type=script&lang=js&"
import style0 from "./tableRegisterReport.vue?vue&type=style&index=0&id=1807e7ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1807e7ce",
  null
  
)

export default component.exports